import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'
import { AdminStore } from 'stylemix-vue-admin'
import store from './store.js'

// AdminStore.registerModule('currencies', store)
AdminStore.registerModule('currencies', {
  namespaced: true,
  state: {
    currencies: [],
  },
  mutations: {
    setCurrencies(state, currencies) {
      state.currencies = currencies
    },
  },
})

const base = 'currencies'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./CurrenciesIndex.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 24,
  header: $vm => $vm.$t('general.menu_settings'),
  text($vm) {
    return $vm.$t('general.currencies')
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-coin-euro',
  permission: 'administer',
})

messageGroups.push('general')
messageGroups.push('currencies')
